import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';

export class Pagination extends Component {
    render() {
        return (
            <ReactPaginate
                previousLabel={
                    <span
                        className={`px-3 py-2 rounded-md border border-gray-600 ${
                            this.props.currentPage === 0
                                ? 'text-gray-500 cursor-not-allowed'
                                : 'text-white hover:bg-gray-700'
                        }`}
                    >
                        {'<<'}
                    </span>
                }
                nextLabel={
                    <span
                        className={`px-3 py-2 rounded-md border border-gray-600 ${
                            this.props.currentPage === this.props.pageDisplayCount - 1
                                ? 'text-gray-500 cursor-not-allowed'
                                : 'text-white hover:bg-gray-700'
                        }`}
                    >
                        {'>>'}
                    </span>
                }
                breakLabel={'...'}
                breakClassName={'text-white'}
                pageCount={this.props.pageDisplayCount}
                marginPagesDisplayed={1}
                pageRangeDisplayed={2}
                onPageChange={this.props.onPageChange}
                containerClassName={'flex justify-center items-center space-x-2 mt-4'}
                pageClassName={
                    'px-3 py-2 rounded-md border border-gray-600 text-white cursor-pointer hover:bg-gray-700'
                }
                activeClassName={'bg-purple-600 text-white'}
                disabledClassName={'text-gray-500 cursor-not-allowed'}
                forcePage={this.props.currentPage}
            />
        );
    }
}

export default Pagination;
